import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {EmpresasService} from "../../superadmin/services/empresas.service";
import {ImpressaoService} from "../../services/impressao.service";
import {NgForm} from "@angular/forms";
import {EnumTamanhoPapel} from "../../../../server/lib/emun/EnumTamanhoPapel";
import {EnumMomentoImprimirAuto} from "../../../../server/lib/emun/EnumMomentoImprimirAuto";
import {DeviceDetectorService} from "ngx-device-detector";
import {ServidorImpressaoService} from "../../services/servidor-impressao.service";
import {DialogRef, DialogService} from "@progress/kendo-angular-dialog";
import {ModalConfirmacaoComponent} from "../cad-horariosfuncionamento/modal-confirmacao.component";
import {KendoPopupUtils} from "../../lib/KendoPopupUtils";
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-config-impressao',
  templateUrl: './config-impressao.component.html',
  styleUrls: ['./config-impressao.component.scss']
})
export class ConfigImpressaoComponent implements OnInit {
  private _empresa: any;
  impressoras: any[] = [];
  conectando = true;
  qzInstalado: boolean;
  salvando: boolean;
  layouts = ['PedidoCompleto', 'PedidoResumido', 'UmPorProduto', 'Personalizado'];
  @ViewChild('frmConfigImpressao')   frmConfigImpressao: NgForm;
  mensagemSucesso: string;
  erro: string;
  listaTamanhosPapeis = [
    EnumTamanhoPapel.Layout80mm,
    EnumTamanhoPapel.Layout80mm42car,
    EnumTamanhoPapel.Layout58mm,
    EnumTamanhoPapel.Layout58mm32car,
    EnumTamanhoPapel.LayoutA4
  ];
  recarregar: boolean
  isMobile: boolean;
  @Input()
  possuiModuloFiscal;

  impressoraSelecionada: any = null;
  indexSelecionado: number = -1;
  impressorasAlteradas: boolean = false;

  // Novas propriedades para servidores de impressão
  servidoresImpressao: any[] = [];
  servidorSelecionado: any = null;
  editandoServidor  = false;
  configurandoLocal  = false;
  modalServidorAberto = false;
  temServidorImpressao  = false;

  // Novas propriedades para fluxo de servidor-impressora
  modoCriacaoRapidaServidor: boolean = false;

  // Novas propriedades para seleção de impressoras
  impressorasDisponiveis: any[] = [];
  impressorasSelecionadas: any[] = [];
  detalhesImpressoras: any = {};
  carregandoDetalhes = false;
  msgErro: string;

  // Dialog layout personalizado
  dialogLayoutAberto = false;
  opcoesLayoutTemp: any = null;
  opcoesLayoutTempAlterado = false;

  previewCarregando = false;
  previewUrl: string | null = null;
  previewUrlSafe: SafeResourceUrl | null = null;

  opcoesLayoutDef: any[] = [
    { key: 'secEmpresa', label: 'Empresa', help: 'Nome/logo no topo' },
    { key: 'secCabecalhoPedido', label: 'Cabeçalho do pedido', help: 'Pedido/Comanda, código, mesa' },
    { key: 'secDataHorario', label: 'Data/Horário', help: 'Data do pedido/comanda e horário' },

    { key: 'secAgendamento', label: 'Agendamento', help: 'Entrega agendada' },
    { key: 'secRetirada', label: 'Retirada', help: 'Mensagem de retirada' },
    //{ key: 'secExterno', label: 'Pedido externo', help: 'iFood/Keeta etc' }, não deveria ser opcional

    { key: 'secDadosCliente', label: 'Dados do cliente', help: 'Bloco do cliente' },
    { key: 'secNomeCliente', label: 'Nome do cliente', help: 'Nome/identificação' },
    { key: 'secTelefoneCliente', label: 'Telefone', help: 'Telefone (se não oculto)' },
    { key: 'secEnderecoEntrega', label: 'Endereço de entrega', help: 'Endereço completo' },
    { key: 'secHistoricoCliente', label: 'Histórico do cliente', help: 'Quantidade de pedidos' },

    { key: 'secItens', label: 'Itens', help: 'Lista de itens' },
    { key: 'secCabecalhoColunasItens', label: 'Cabeçalho colunas', help: 'Descrição/Qtde/Total' },
    { key: 'secTotalItem', label: 'Total por item', help: 'Coluna total (não resumido)' },

    { key: 'secAdicionais', label: 'Adicionais', help: 'Adicionais do item' },
    { key: 'secObsItem', label: 'Obs do item', help: 'Observação por item' },

    { key: 'secPagamentos', label: 'Pagamentos', help: 'Seção de pagamentos' },
    { key: 'secObsPedido', label: 'Obs do pedido', help: 'Observações gerais' },
    { key: 'secPontos', label: 'Pontos', help: 'Fidelidade' },

    { key: 'secGarcom', label: 'Garçom', help: 'Nome do garçom' },

    { key: 'secAssinatura', label: 'Assinatura', help: 'Linha de assinatura' },
    { key: 'secOperador', label: 'Operador', help: 'Nome do operador' },
    { key: 'secImpressoEm', label: 'Impresso em', help: 'Data/hora impressão' },
    { key: 'secRodape', label: 'Rodapé', help: 'Texto final' }
  ];
  @Input()
  set empresa(empresa: any) {
    if(!empresa.configImpressao)
      empresa.configImpressao = {}

    if(!empresa.configImpressao.momentoImprimirAuto)
      empresa.configImpressao.momentoImprimirAuto =  EnumMomentoImprimirAuto.StatusPedido

    if(empresa.configImpressao.imprimirOnlineNaoPago === undefined)
      empresa.configImpressao.imprimirOnlineNaoPago = false

    // Garante que impressoras tenham setor preenchido
    if (empresa.configImpressao.impressoras) {
      empresa.configImpressao.impressoras.forEach(impressora => {
        if (!impressora.setor && impressora.nome) {
          impressora.setor = impressora.nome;
        }
      });
    }

    this._empresa = empresa;
  }

  get empresa() {
    return this._empresa;
  }

  // Propriedades para controle do servidor local
  isServidorLocal = false;
  servidorLocalConfigurado: any;

  constructor(
    private empresaService: EmpresasService,     private dialogService: DialogService,
    private impressao: ImpressaoService,
    private deviceService: DeviceDetectorService,
    private servidorImpressaoService: ServidorImpressaoService,
    private sanitizer: DomSanitizer
  ) {
    this.isMobile = this.deviceService.isMobile()
    if(this.isMobile) this.conectando = false;
  }

  async ngOnInit(): Promise<void> {
    // Força multiplasImpressoras sempre como true
    if (this.empresa?.configImpressao)
      this.empresa.configImpressao.multiplasImpressoras = true;

    // Carregar servidores de impressão
    await this.carregueServidoresImpressao();
    await this.verificarServidorLocal();
  }

  conectouQzTray(){
    this.qzInstalado = true;
    this.conectando = false;

    this.carregueImpressoras();
    this.carregueImpressorasDisponiveis()
  }

  private async verificarServidorLocal(): Promise<void> {
    try {
      // Verificar se este computador já está configurado como servidor
      this.servidorLocalConfigurado =  await this.servidorImpressaoService.getServidorRegistrado();

      if (this.servidorLocalConfigurado) {
        this.isServidorLocal = true;
        console.log('Este computador já está configurado como servidor de impressão');
      }
    } catch (erro) {
      console.error('Erro ao verificar servidor local:', erro);
    }
  }


  alterouTipoDeImpressao() {
    if(this.empresa.configImpressao.imprimirTXT) {
      if(!this.empresa.configImpressao.impressoras)
        this.empresa.configImpressao.impressoras = []

      if(!this.empresa.configImpressao.impressoras.find( impressora => !impressora.removida))
        this.empresa.configImpressao.impressoras.push({})

      this.carregueImpressoras()
    }
  }

  carregueImpressoras(){
    if(this.impressoras.length === 0){
      this.impressao.listeImpressoras().then((resultado: any) => {
        if(resultado.sucesso)
          this.impressoras = resultado.data;
        else
          this.erro = 'Houve um erro ao carregar a lista de impressoras: ' + resultado.erro;
      })
    }
  }

  carregueImpressorasDisponiveis() {
    let impressorasEmpresa: Array<any> = this.empresa.configImpressao.impressoras;

    this.impressorasDisponiveis = impressorasEmpresa.filter(
      (item: any) => !item.servidorImpressao);


    this.impressorasSelecionadas.forEach((impressora) => {
      this.impressorasDisponiveis.splice(0, 0, impressora)
    })

   /* if ( this.qzInstalado) {
      this.impressao.listeImpressoras().then((resultado: any) => {
        if (resultado.sucesso) {
          this.impressorasDisponiveis = resultado.data;
          // Filtrar impressoras que não estão vinculadas a outros servidores
          this.filtreImpressorasDisponiveis();
        } else {
          this.erro = 'Houve um erro ao carregar a lista de impressoras: ' + resultado.erro;
        }
      });
    } */
  }

  filtreImpressorasDisponiveis() {
    // Remover impressoras que já estão vinculadas a outros servidores
    this.impressorasDisponiveis = this.impressorasDisponiveis.filter(imp => {
      // Verificar se a impressora já está vinculada a outro servidor
      const servidorVinculado = this.servidoresImpressao.find(servidor =>
        servidor.impressoras && servidor.impressoras.find(impServidor =>
          impServidor.nome === imp && servidor.id !== this.servidorSelecionado?.id
        )
      );
      return !servidorVinculado;
    });
  }

  async obtenhaDetalhesImpressora(nomeImpressora: string): Promise<any> {
    if (this.detalhesImpressoras[nomeImpressora]) {
      return this.detalhesImpressoras[nomeImpressora];
    }

    try {
      this.carregandoDetalhes = true;

      // Usar QZ Tray para obter detalhes da impressora
      const detalhes = await this.impressao.obtenhaDetalhesImpressora(nomeImpressora);

      if (detalhes && detalhes.sucesso) {
        this.detalhesImpressoras[nomeImpressora] = detalhes.data;
        return detalhes.data;
      } else {
        // Fallback para informações básicas
        return {
          nome: nomeImpressora,
          status: 'Disponível',
          localizacao: 'Local',
          tipo: 'Impressora Local'
        };
      }
    } catch (erro) {
      console.error('Erro ao obter detalhes da impressora:', erro);
      return {
        nome: nomeImpressora,
        status: 'Erro ao obter detalhes',
        localizacao: 'Desconhecido',
        tipo: 'Impressora Local'
      };
    } finally {
      this.carregandoDetalhes = false;
    }
  }

  toggleImpressoraSelecionada(impressora: string) {
    const index = this.impressorasSelecionadas.indexOf(impressora);
    if (index > -1) {
      this.impressorasSelecionadas.splice(index, 1);
    } else {
      this.impressorasSelecionadas.push(impressora);
    }
  }

  impressoraEstaSelecionada(impressora: string): boolean {
    return this.impressorasSelecionadas.includes(impressora);
  }

  podeSalvarServidor(): boolean {
    if (this.modoCriacaoRapidaServidor) {
      return !!this.servidorSelecionado?.nome;
    }

    return this.servidorSelecionado?.nome &&
           this.impressorasSelecionadas.length > 0;
  }

  onSubmitConfigImpressao() {
    this.mensagemSucesso = '';
    delete this.erro;
    if( !this.frmConfigImpressao.valid || this.salvando)   return;

    this.salvando = true;
    this.empresaService.salveConfigImpressao(this.empresa).then( (configImpressao) => {
      this.empresa.configImpressao = configImpressao;
      this.impressorasAlteradas = false;
      if(!this.recarregar){
        this.salvando = false;
        this.mensagemSucesso = "As configurações de impressão foram atualizadas";
      } else {
        location.reload();
      }
    }).catch( (erro) => {
      this.salvando = false;
      this.erro = erro;
    });
  }

  adicionarNovaImpressa() {
    const novaImpressora = {
      novo: true,
      imprimirAutomatico: true, // valores padrão se desejar
      layout: this.layouts[0]
    };

    this.empresa.configImpressao.impressoras.push(novaImpressora);
    const index = this.empresa.configImpressao.impressoras.length - 1;

    // Abre o popup imediatamente
    this.abrirConfigImpressora(novaImpressora, index);
  }

  alterouLeiaute() {
    if(this.empresa.configImpressao.layoutPedido !== 'Ambos'){
      this.layouts = [this.empresa.configImpressao.layoutPedido]

      if(this.empresa.configImpressao.impressoras)
        this.empresa.configImpressao.impressoras.forEach( (impressora: any) => {
          if(impressora.layout !== this.empresa.configImpressao.layoutPedido )
            delete impressora.layout
        })
    } else {
      this.layouts  = ['PedidoCompleto', 'PedidoResumido', 'UmPorProduto'];
    }
  }

  excluirImpressora(impressora){
    if(impressora.id){
      impressora.removida = true;
    } else {
      this.empresa.configImpressao.impressoras.splice(  this.empresa.configImpressao.impressoras.indexOf(impressora), 1)
    }
    this.impressorasAlteradas = true;
  }

  marqueRecarregar() {
    this.recarregar = true;
  }

  abrirConfigImpressora(impressora: any, index: number) {
    this.impressoraSelecionada = {...impressora};
    // Garante que ao abrir o popup, o setor já esteja preenchido
    if (!this.impressoraSelecionada.setor && this.impressoraSelecionada.nome)
      this.impressoraSelecionada.setor = this.impressoraSelecionada.nome;


    this.indexSelecionado = index;
    // Preparar seleção atual de servidor
    if (this.impressoraSelecionada.servidorImpressao ) {
      this.impressoraSelecionada.imprimirApenasNesteComputador = true;
      this.impressoraSelecionada.servidorImpressao = this.servidoresImpressao.find(
        (item: any) => item.id === this.impressoraSelecionada.servidorImpressao.id )
    }
  }

  fecharConfigImpressora() {
    // Se for uma nova impressora e não foi configurada, remove
    if (this.impressoraSelecionada?.novo && !this.impressoraSelecionada.nome) {
      const index = this.empresa.configImpressao.impressoras.findIndex(
        imp => imp === this.impressoraSelecionada
      );
      if (index > -1) {
        this.empresa.configImpressao.impressoras.splice(index, 1);
      }
    }

    this.impressoraSelecionada = null;
    this.indexSelecionado = -1;
  }

  salvarConfigImpressora(frmImpressora: NgForm) {
    this.msgErro = null;

    if(!frmImpressora.valid){
       this.msgErro = 'verifique campos obrigatórios'
       return;
    }

    if (this.indexSelecionado >= 0) {
      delete this.impressoraSelecionada.novo;

      // Se não tiver setor, usa o nome da impressora
      if (!this.impressoraSelecionada.setor && this.impressoraSelecionada.nome) {
        this.impressoraSelecionada.setor = this.impressoraSelecionada.nome;
      }

      // Atualiza associação com servidor selecionado
      if (!this.impressoraSelecionada.imprimirApenasNesteComputador)
        delete this.impressoraSelecionada.servidorImpressao;

      this.empresa.configImpressao.impressoras[this.indexSelecionado] = {...this.impressoraSelecionada};
      this.impressorasAlteradas = true;
    }
    this.fecharConfigImpressora();
  }

  // Também podemos adicionar um watch na mudança do nome da impressora
  onImpressoraNomeChange() {
    if (!this.impressoraSelecionada.setor && this.impressoraSelecionada.nome) {
      this.impressoraSelecionada.setor = this.impressoraSelecionada.nome;
    }
  }


  // NOVOS MÉTODOS PARA SERVIDORES DE IMPRESSÃO

  async carregueServidoresImpressao(): Promise<void> {
    try {
      this.servidoresImpressao = await this.servidorImpressaoService.listeServidores();
      this.temServidorImpressao = this.servidoresImpressao.length > 0;
    } catch (erro) {
      console.error('Erro ao carregar servidores de impressão:', erro);
      this.erro = 'Erro ao carregar servidores de impressão';
    }
  }

  editarServidorDaImpressora(impressora: any){
    let servidor = this.servidoresImpressao.find((item: any) => item.id === impressora.servidorImpressao.id)

    this.editarServidor(servidor);
  }

  obtenhaStatusServidor(servidor: any): string {
    if (!servidor.ativo) return 'Inativo';

    // Verificar se está ativo baseado na última atividade
    const agora = new Date();
    const cincoMinutosAtras = new Date(agora.getTime() - 5 * 60 * 1000);

    if (servidor.ultimaAtividade && new Date(servidor.ultimaAtividade) > cincoMinutosAtras) {
      return 'Ativo';
    }

    return 'Inativo (Timeout)';
  }

  obtenhaStatusClass(servidor: any): string {
    if (!servidor.ativo) return 'status-inativo';

    const agora = new Date();
    const cincoMinutosAtras = new Date(agora.getTime() - 5 * 60 * 1000);

    if (servidor.ultimaAtividade && new Date(servidor.ultimaAtividade) > cincoMinutosAtras) {
      return 'status-ativo';
    }

    return 'status-timeout';
  }

  limparMensagens(): void {
    this.mensagemSucesso = '';
    this.erro = '';
  }

  // Checkbox: imprimir apenas nesse computador
  onToggleImprimirApenasNesteComputador(): void {
    if (!this.impressoraSelecionada.imprimirApenasNesteComputador) {

      delete this.impressoraSelecionada.servidorImpressao;
    }
  }

  novoServidorRapido(): void {
    this.modoCriacaoRapidaServidor = true;
    this.msgErro = null;

    if(this.isServidorLocal){
      let servidor = this.servidoresImpressao.find((item: any) => item.id === this.servidorLocalConfigurado.id)
      this.impressoraSelecionada.servidorImpressao = servidor;
    } else {
      this.abrirConfigServidorImpressao();
    }
  }

  editarServidor(servidor: any): void {
    this.servidorSelecionado = { ...servidor };
    this.editandoServidor = true;
    this.modalServidorAberto = true;

    this.servidorSelecionado.isServidorLocal = this.isServidorLocal

    setTimeout(() => {
      // this.modalServidorImpressao.setServidor()
    }, 0)

  }

  abrirConfigServidorImpressao(): void {
    this.modalServidorAberto = true;
    this.editandoServidor = false;
    this.servidorSelecionado = { computadorId: this.servidorImpressaoService.getIdentificacaoMaquina(), ativo: true};
    this.impressorasSelecionadas = [];
    this.detalhesImpressoras = {};
    this.carregueImpressorasDisponiveis();
  }


  salvouServidor(servidor: any){
    this.fecharModalServidor();

    if(servidor.id){
      this.servidoresImpressao.push(servidor)
      if(this.impressoraSelecionada)
        this.impressoraSelecionada.servidorImpressao = servidor;
    }
  }

  fechouModalServidor(result){
    this.fecharModalServidor();

    if(result && result.recarregar)
      this.carregueServidoresImpressao().then(() => { });
  }


  fecharModalServidor(): void {
    this.modalServidorAberto = false;
    this.editandoServidor = false;
    this.servidorSelecionado = null;
    this.configurandoLocal = false;
    this.impressorasSelecionadas = [];
    this.detalhesImpressoras = {};
    this.modoCriacaoRapidaServidor = false;
  }

  trackByOpcaoLayout(index: number, item: any){
    return item.key;
  }

  getDefaultOpcoesLayout(): any {
    const obj: any = {};
    this.opcoesLayoutDef.forEach(o => obj[o.key] = true);
    return obj;
  }

  ensureOpcoesLayoutImpressora(): void {
    if(!this.impressoraSelecionada) return;

    if(!this.impressoraSelecionada.opcoesLayout)
      this.impressoraSelecionada.opcoesLayout = this.getDefaultOpcoesLayout();

    const defaults = this.getDefaultOpcoesLayout();
    Object.keys(defaults).forEach(k => {
      if(this.impressoraSelecionada.opcoesLayout[k] === undefined || this.impressoraSelecionada.opcoesLayout[k] === null)
        this.impressoraSelecionada.opcoesLayout[k] = true;
    });
  }

  abrirDialogLayoutPersonalizado(): void {
    this.previewCarregando = false;
    this.opcoesLayoutTempAlterado = false;

    this.ensureOpcoesLayoutImpressora();

    // clone simples
    this.opcoesLayoutTemp = { ...this.impressoraSelecionada.opcoesLayout };

    this.dialogLayoutAberto = true;

    setTimeout(() => {
      this.atualizarPreviewLayoutTemp();
    }, 0);
  }

  fecharDialogLayoutPersonalizado(aplicar: boolean): void {
    if(aplicar && this.opcoesLayoutTemp){
      this.impressoraSelecionada.opcoesLayout = { ...this.opcoesLayoutTemp };
    }

    this.dialogLayoutAberto = false;
    this.opcoesLayoutTemp = null;
    this.opcoesLayoutTempAlterado = false;
    this.previewCarregando = false;
    // opcional: manter preview ou limpar
    // this.previewHtml = null;
  }

  alterouOpcoesLayoutTemp() {
    this.atualizarPreviewLayoutTemp();
    this.previewCarregando = true;
  }

  atualizarPreviewLayoutTemp() {
    const url = this.impressao.getPreviewLayoutUrl({
      idImpressora: this.impressoraSelecionada?.id,
      opcoesLayout: this.opcoesLayoutTemp,
      resumido: false
    });

    this.previewUrl = url;
    this.previewUrlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  marcarTodosOpcoesLayoutTemp(valor: boolean){
    if(!this.opcoesLayoutTemp)
      this.opcoesLayoutTemp = this.getDefaultOpcoesLayout();

    this.opcoesLayoutDef.forEach(o => this.opcoesLayoutTemp[o.key] = valor);
    this.opcoesLayoutTempAlterado = true;
  }

  getPreviewPaperWidth(): string {
    if(!this.impressoraSelecionada) return '75mm';

    const tp = this.impressoraSelecionada.tamanhoPapel;
    if(tp === EnumTamanhoPapel.Layout58mm || tp === EnumTamanhoPapel.Layout58mm32car) return '53mm'; // seu CSS
    return '75mm';
  }


  alterouLayoutImpressora(){
    if(this.impressoraSelecionada?.layout === 'Personalizado')
      this.ensureOpcoesLayoutImpressora();
  }

  onIframeLoad() {
    this.previewCarregando = false;
  }
}
